module.exports = __webpack_public_path__ + "img/Ello-2.60691ca2.png";